<template>
<section class="">
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="col-md-6 p-2 text-center">
                <h3 class="heading_comp_name">DCSCloud</h3>
            </div>
        </div>    
    </div>             
    <div class="container-fluid pl-3 login-page">
        <div class="row justify-content-center">
            <div class="col-md-4 p-2">
             <div class="form-inner">
              <div class="smallbar bg-danger"></div>
               <div class="logo text-center"><img width="44" height="44" src="static/images/logo.png"><span class="text-primary">WTIPS</span><span class="align-top text-dark"><strong>V3</strong></span></div>
                    <h1 class="display-4">Logging out ...</h1>
                    <p class="lead">please wait</p>
               <p></p>
              </div>               
            </div>    
        </div>    
    </div>
     <footer class="footer">        
          <div class="container">
              <div class="row">
                <div class="col">   
                   <p class="text-dark">&copy; 2018 - <a class="text-dark" href="http://www.dcscloudsolutions.com" >DCSCloud</a> <a href="http://www.dcscloudsolutions.com" class="external"> an Enterprise resource planner.</a></p>
                </div>
                <div class="col text-right">
                   <div class="icon lead">
                       <a class="text-dark" href="#"><i class="p-2 fa fa-facebook-square"></i></a>
                       <a class="text-dark" href="#"><i class="p-2 fa fa-twitter-square"></i></a>
                       <a class="text-dark" href="#"><i class="p-2 fa fa-linkedin-square"></i></a>
                       <a class="text-dark" href="#"><i class="p-2 fa fa-youtube-square"></i></a>
                   </div>
                </div>    
              </div>
          </div>
     </footer>

</section>
</template>

<script>
import spinner from '@/components/supportcomp/spinner.vue'    
    
export default {
  name: 'logout',
  data () {
    return {
      msg: '',
      username: '',
      password: '',
      dynamicLoginIndex : 0,
      ajax_loader: false  
    }
  },
  components: {
         spinner
      },    
 methods: {
    logout: function () {
             var locData = this;
                $(location).attr('href','./#/');
             // Login Ajax
                /*
                $.ajax({
                  type: 'POST',
                  url:  ajaxurl+'logout' , //'http://192.168.1.230:3000/auth_token_dcs',
                  contentType: "application/json",    
                  async: true,
                  data: '',
                  beforeSend: function (xhr) { 
                      
                      locData.ajax_loader=true;
                      xhr.setRequestHeader("Authorization", "Bearer " + apikey);
                                          
                  },
                  complete: function () { locData.ajax_loader=false; },     
                  success: function(data)
                  {
                	return data;
                  },
                  dataType: 'json',
                  error: function (xhr, ajaxOptions, thrownError) {
                    //alert(xhr.status);
                    //alert(thrownError);
               if (xhr.status == '401' )
                {
                     if ( thrownError == 'Unauthorized')
                       {

                            notify('User not authorized, Please re-login', 'warn',true,false,'top left');   
                            $(location).attr('href','/#/');
                       }   
                 }
                      
                      if (xhr.status == '0' )
                          {
                              notify('Internet connection is not available', 'warn',true,false,'top center');  
                          }          
                      if (xhr.status == '500' )
                          {
                              notify('Service not available, Internal Server Error', 'warn',true,false,'top center');  
                          }
                  }    
                  }).done(function (data_value) {
            
                	    if (data_value.result == "logout_success")
                	    {

                           apikey="";
                           $(location).attr('href','/#/');                            
                           
            
                	    }    	    	
                	    else
                	    {
                               
            
                	    }
                  });  
                  */

            
           } //logout method
  }, //methods    
mounted : function () {
            var x = this;
     setTimeout(function(){ x.logout(); }, 200);
  }
} //end component
</script>

<style scoped>

@font-face {
    font-family: 'BebasNeueRegular';
    src: url('static/fonts/BebasNeue-webfont.eot');
    src: url('static/fonts/BebasNeue-webfont.eot?#iefix') format('embedded-opentype'),
         url('static/fonts/BebasNeue-webfont.woff') format('woff'),
         url('static/fonts/BebasNeue-webfont.ttf') format('truetype'),
         url('static/fonts/BebasNeue-webfont.svg#BebasNeueRegular') format('svg');
    font-weight: normal;
    font-style: normal;
}

.heading_comp_name { 

    font-family: 'BebasNeueRegular', 'Arial Narrow', Arial, sans-serif;
    font-size: 100px;    

}

.smallbar{

  height: 5px;

}
.CusAdvisery {

      font-family: "Roboto", sans-serif;
    font-size: 10px;}

.CusAdvisery_help {

      font-family: "Roboto", sans-serif;
      font-size: 14px;}

.footer {
  position: absolute;
  bottom: 0;
  width: 100%;
}

</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->




// WEBPACK FOOTER //
// src/components/logout.vue